/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{DataType as N}from"../../../../webgl/enums.js";const T={[N.BYTE]:1,[N.UNSIGNED_BYTE]:1,[N.SHORT]:2,[N.UNSIGNED_SHORT]:2,[N.HALF_FLOAT]:2,[N.INT]:4,[N.UNSIGNED_INT]:4,[N.FLOAT]:4};export{T as dataSizeInBytes};
